import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardShopIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0004 9.13672V6.13672C16.0004 3.92758 14.2095 2.13672 12.0004 2.13672C9.79123 2.13672 8.00037 3.92758 8.00037 6.13672V9.13672M3.59237 10.4887L2.99237 16.8887C2.82178 18.7084 2.73648 19.6182 3.03842 20.321C3.30367 20.9383 3.76849 21.4488 4.35839 21.7705C5.0299 22.1367 5.94374 22.1367 7.77142 22.1367H16.2293C18.057 22.1367 18.9708 22.1367 19.6423 21.7705C20.2322 21.4488 20.6971 20.9383 20.9623 20.321C21.2643 19.6182 21.179 18.7084 21.0084 16.8887L20.4084 10.4887C20.2643 8.95207 20.1923 8.18376 19.8467 7.60288C19.5424 7.0913 19.0927 6.68183 18.555 6.42656C17.9444 6.13672 17.1727 6.13672 15.6293 6.13672L8.37142 6.13672C6.82806 6.13672 6.05638 6.13672 5.44579 6.42656C4.90803 6.68183 4.45838 7.0913 4.15403 7.60288C3.80846 8.18375 3.73643 8.95206 3.59237 10.4887Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardShopIcon;
